/**
 * 表情控件
 * Bai.Zhiming
 * 2019-7-24
 */
angular.module("emotionsModule", []).
directive('emotions', ["$timeout", function($timeout) {
    return {
        restrict: "A",
        replace: false,
        scope: {
            fn: "="
        },
        templateUrl: './IM/chatWindow/dialogBox/directive/emotions/emotions_tpl.html',
        link(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    showEmotionsBar: false,
                    emotionsBaseUrl: './images/emotions/'
                };
                scope.data = {
                    emotions: []
                };
                initShowClick();
                initBlur();
            }
            /**
             * [getEmotion description] 获取表情
             * @param  {[type]} emotion [description] 表情信息
             * @return {[type]}         [description]
             */
            scope.getEmotion = function(emotion) {
                if (angular.isFunction(scope.fn.getEmotion)) {
                    scope.fn.getEmotion(angular.copy(emotion));
                }
            };
            /**
             * [initShowClick description] 初始化点击显示事件
             * @return {[type]} [description]
             */
            function initShowClick() {
                $element.click(e => {
                    if (!scope.status.showEmotionsBar && angular.isFunction(scope.fn.emotionsShow)) {
                        scope.fn.emotionsShow();
                    }
                    $timeout(() => {
                        scope.status.showEmotionsBar = !scope.status.showEmotionsBar;
                    });
                });
            }
            /**
             * [initBlur description] 初始化失焦
             * @return {[type]} [description]
             */
            function initBlur() {
                $("body").bind("click", myBlur);

                function myBlur(e) {
                    let $target = $(e.target);
                    if ($target[0] == $element[0]) return;
                    if ($target.parents(".im_emotions")[0] == $element[0]) return;
                    $timeout(() => {
                        scope.status.showEmotionsBar = false;
                    });
                }
                scope.$on("$destroy", () => {
                    $("body").unbind("click", myBlur);
                });
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getEmotions();
            }
            /**
             * [getEmotions description] 获取表情包
             * @return {[type]} [description]
             */
            function getEmotions() {
                for (let i = 1; i <= 105; i++) {
                    scope.data.emotions.push({
                        num: i,
                        src: `${scope.status.emotionsBaseUrl}${i}.png`
                    });
                }
            }
        }
    };
}]);